import {
    ButtonBase,
    ListItem,
    makeStyles, Menu,
    MenuItem
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { NavBarContext } from '.';

const useStyles = makeStyles((theme) => ({
    item: {
        display: 'block',
        paddingTop: 0,
        paddingBottom: 0
    },
    itemLeaf: {
        display: 'flex',
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        fontSize: theme.typography.fontSize,
        color: theme.palette.text.secondary,
        padding: '10px 8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        borderRadius: theme.shape.borderRadius
    },
    menu: {
        pointerEvents: 'none'
    },
    menuItem: {
        pointerEvents: 'auto',
        fontSize: theme.typography.fontSize
    },
    buttonLeaf: {
        color: theme.palette.text.secondary,
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
        fontWeight: theme.typography.fontWeightRegular,
        '&.depth-0': {
            '& $title': {
                fontWeight: theme.typography.fontWeightMedium
            }
        }
    },
    icon: {
        marginBottom: theme.spacing(1)
    },
    title: {
        whiteSpace: 'nowrap',
        fontWeight: theme.typography.fontWeightMedium
    },
    active: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightMedium
    }
}));

function FoldNavItem({
    title,
    href,
    depth,
    children,
    icon: Icon,
    className,
    info: Info,
    items,
    onClick,
    ...rest
}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { toggleDrawerMenu } = useContext(NavBarContext);
    const handleMouseEnter = (event) => {
        setAnchorEl(event.currentTarget);

    };
    const handleMouseLeave = () => {
        setAnchorEl(null);
    };


    const handleClose = () => {
        setAnchorEl(null);

    };
    const handleClick = () => {
        toggleDrawerMenu(items);
    };

    let paddingLeft = 8;

    if (depth > 0) {
        paddingLeft = 32 + 8 * depth;
    }

    const style = { paddingLeft };

    return (
        <ListItem
            className={clsx(classes.item, className)}
            disableGutters
            aria-haspopup="true"
            key={title}
            {...rest}
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        >
            <ButtonBase
                // activeClassName={classes.active}
                className={classes.button}
                style={style}
                // component={href ? RouterLink : "button"}
                // to={href}
                onClick={handleClick}
            >
                {Icon && (
                    <Icon
                        className={classes.icon}
                        size="20"
                    />
                )}

                <span className={classes.title}>
                    {title}
                </span>
            </ButtonBase>
            {/* {
                items && <Menu
                    className={classes.menu}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        horizontal: -20,
                        vertical: 'center'
                    }}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {items.map((item, key) => {
                        return (
                            <MenuItem
                                activeClassName={classes.active}
                                key={item.title}
                                component={RouterLink}
                                to={item.href}
                                className={classes.menuItem}
                                onClick={handleClose}
                            >
                                {item.title}
                            </MenuItem>
                        );
                    })}
                </Menu>
            } */}

        </ListItem>
    );
}

FoldNavItem.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    depth: PropTypes.number.isRequired,
    href: PropTypes.string,
    icon: PropTypes.any,
    info: PropTypes.any,
    title: PropTypes.string.isRequired,
    items: PropTypes.array
};

FoldNavItem.defaultProps = {
    // open: false
};

export default FoldNavItem;
